<section class="panel">
    <iframe [src]="pdfSrc| safe" class="pdf-viewer" >
  
    </iframe>  
  </section>